<template>
  <div class="separator">
    <hr class="gradient-line" />
    <slot></slot>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  color: {
    type: String,
    default: "rainbow",
  },
});

// Gradients symétriques SANS transparence aux extrémités : la ligne est
// animée (balayage type "steam", cf. bordure de ModuleCtn) et le fondu des
// bouts est fait par un mask fixe — sinon les pointes transparentes
// traverseraient la ligne pendant l'animation.
// Bases volontairement claires : le balayage fait passer la zone visible
// sur tout le gradient, la ligne doit rester lumineuse à chaque phase.
const gradientColors = {
  rainbow:
    "linear-gradient(90deg, #f4a719 0%, #e0705a 25%, #d76ad8 50%, #a55ae8 75%, #6e8ce0 100%)",
  pink: "linear-gradient(90deg, #c573e8 0%, #ff9dff 50%, #c573e8 100%)",
  gold: "linear-gradient(90deg, #d98a10 0%, #ffc547 25%, #fff3cf 50%, #ffc547 75%, #d98a10 100%)",
  red: "linear-gradient(90deg, #e06a3a 0%, #ff9d6b 25%, #ffd9c0 50%, #ff9d6b 75%, #e06a3a 100%)",
  purple: "linear-gradient(90deg, #c66ae0 0%, #ee9bff 25%, #ffe2ff 50%, #ee9bff 75%, #c66ae0 100%)",
};

const backgroundGradient = computed(() => gradientColors[props.color]);
</script>

<style lang="scss" scoped>
.separator {
  width: 100%;
}

// Ligne unique, animée dans le même style (et à la même cadence) que la
// bordure des modules : background 400% balayé par "steam" 10s linear —
// les deux animations restent visuellement synchrones, et l'animation de
// background-position ne coûte que de la peinture locale (pas de layout).
.gradient-line {
  width: 100%;
  margin: 0;
  border: none;
  height: 0.1rem;
  background: v-bind(backgroundGradient);
  background-size: 400% 100%;
  animation: steam 10s linear infinite;
  -webkit-mask: linear-gradient(90deg, transparent 0%, #fff 8%, #fff 92%, transparent 100%);
  mask: linear-gradient(90deg, transparent 0%, #fff 8%, #fff 92%, transparent 100%);
}

@keyframes steam {
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}
</style>
